<template>
  <div class="snap">
    <img src="@/assets/promo/snap_promo.png" alt="Snap Dragon Challenge" class="promo">
    <a href="https://www.amazon.com/Created-By-Intelligent-Design-Challenge/dp/B00JJD8F3S/ref=sr_1_3?dchild=1&qid=1598738716&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-3">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Survive the Hive!</h2>
    <br>
    <p class="app-blurb">This gladiator arena was made for Dragons...and you're it! So get at it and kill
      some Archers, Shock Maggots and Swarm before you end up dinner!
    </p>
    <br><br>
    <iframe
      src="https://www.youtube.com/embed/RcxE7J3c3YU"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :style="embedHeight"></iframe>
    <img src="@/assets/screenshots/snap_01.png" alt="">
    <img src="@/assets/screenshots/snap_02.png" alt="">
    <img src="@/assets/screenshots/snap_03.png" alt="">
    <img src="@/assets/screenshots/snap_04.png" alt="">
    <img src="@/assets/screenshots/snap_05.png" alt="">
    <img src="@/assets/screenshots/snap_06.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Snap',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.snap {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
}
.snap img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 80%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
